export default __webpack_public_path__ + "static/media/discover-on-white.610be3f1.svg";